import { Component, Input, HostBinding } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-button',
  imports: [CommonModule],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
})
export class ButtonComponent {
  @Input() backgroundColor="#57DF8E";
  @Input() textColor="#fff";
  @Input() hoverBackgroundColor="#56FA98";
  @Input() hoverTextColor="#fff";
  @Input() border = '1px solid rgba(229, 229, 229, 0.22)';
  @Input() label = '';
  @Input() iconLeft = '';
  @Input() iconRight = '';
  @Input() iconColor = '#fff';
  @Input() fontSize = 21;
  @Input() showOutlineOnHover = false;
  @Input() disabled = false;
  @Input() degrees = 0;
  @Input() waitCursor = false;

  @HostBinding('class.disabled') get isDisabled(): boolean {
    return this.disabled;
  }

  @HostBinding('class.wait-cursor') get hasWaitCursor(): boolean {
    return this.waitCursor;
  }

  get rotate(): string {
    return `rotate(${this.degrees}deg)`;
  }
}
